import parsePhoneNumber from 'libphonenumber-js'

// Note: Remember to use this function only for phone numbers created with PhoneNumberInput component
// It will not work properly for phone numbers without the country code
// For now we have to add '+' sign manually due to huge refactor needed on the backend side
export const formatInternationalNumber = (phoneNumber: string | number) => {
  const numberWithCountryCode = phoneNumber.toString().startsWith('+')
    ? phoneNumber.toString()
    : `+${phoneNumber.toString()}`
  return parsePhoneNumber(numberWithCountryCode)?.formatInternational()
}
